// Machine-drafted — review with a native speaker before launch.
const schedule = {
	schedule: {
		// Shared
		cancel: 'Annuler',
		next: 'Suivant',
		continue: 'Continuer',
		loading: 'Chargement ...',
		edit: 'Modifier',
		yes: 'Oui',
		no: 'Non',
		add: 'Ajouter',
		update: 'Mettre à jour',
		errorTitle: 'Erreur',
		oops: 'Oups !',
		searchRecipients: 'Rechercher des destinataires',

		// Header
		editCard: 'Modifier la carte',

		// Progress bar / steps
		progress: 'Progression',
		step1: 'Étape 1',
		step2: 'Étape 2',
		step3: 'Étape 3',
		letsSendYourCard: 'Envoyons votre carte',
		stepAddRecipients: 'Ajoutez des destinataires',
		stepConnectEmail: 'Connectez votre compte de messagerie',
		stepCustomizeSubject: "Personnalisez l'objet",

		// Sender detail / email account
		selectEmailAccount: 'Sélectionnez un compte de messagerie',
		selectPreferredEmail: 'Sélectionnez votre compte de messagerie préféré pour envoyer des cartes.',
		noEmailAccounts: 'Aucun compte de messagerie à afficher',
		addNewEmailAccount: '+ Ajouter un nouveau compte de messagerie',
		confirmEmailAccount: 'Confirmer le compte de messagerie',
		sendUsingDefaultTitle: 'Envoyer via notre système de messagerie par défaut',
		sendViaDefault: "Envoyer via l'adresse e-mail par défaut",
		connectPersonalEmail: 'Veuillez connecter votre adresse e-mail personnelle',
		orSendDefaultAccount: 'ou envoyer via notre compte par défaut.',
		selectCustomEmailError:
			'Veuillez sélectionner un compte de messagerie personnalisé pour programmer la carte ou choisir l’option d’envoi via notre e-mail par défaut.',
		planNoCustomEmail:
			'Votre forfait ne permet pas d’ajouter des comptes de messagerie personnalisés. Veuillez mettre à niveau votre forfait',
		emailAccountsLimitReached:
			'Vous avez atteint la limite de comptes de messagerie. Veuillez mettre à niveau votre forfait pour ajouter d’autres comptes',

		// Add recipient intro / empty state
		addRecipientsIntro:
			'Vous pouvez ajouter des destinataires individuellement ou importer une liste de contacts en téléchargeant un CSV en masse',
		noRecipientsYet: "Vous n'avez pas encore de destinataires.",
		addNamesEmails: 'Ajoutez les noms et les adresses e-mail des destinataires de votre carte.',
		uploadCsv: 'Téléverser un CSV',
		addRecipient: 'Ajouter un destinataire',

		// Contact list
		prepareContactList: 'Préparons votre liste de contacts',
		fileUploadedPrepare:
			'Votre fichier a été téléversé avec succès. Préparons-le maintenant pour la personnalisation des cartes',
		contactListTitle: 'Titre de la liste de contacts',
		whatIsContactList: "Qu'est-ce qu'une liste de contacts ?",
		contactListDescription:
			'Une liste de contacts est un carnet d’adresses que vous pouvez utiliser à tout moment pour envoyer des cartes personnalisées et en masse',
		noCsvSelected: 'aucun fichier csv sélectionné',

		// Merge tags
		selectMergeTags: 'SÉLECTIONNER LES BALISES DE FUSION',
		whatIsMergeTag: "Qu'est-ce qu'une balise de fusion ?",
		mergeTagDescription:
			'Les balises de fusion sont des balises personnalisées associées à vos données en masse pour personnaliser des documents, des graphiques, etc.',
		enterTagName: 'Saisissez le nom de la balise',
		addNewMergeTagBtn: 'Ajouter une nouvelle balise de fusion',
		duplicateMergeTag: 'Impossible d’ajouter une balise de fusion portant le même nom.',

		// Upload CSV modal
		uploadCsvHere: 'Téléversez votre fichier CSV ici',
		uploadCsvDescription:
			'Une fois votre CSV téléversé, %{app} associera vos données aux balises de fusion disponibles ainsi qu’à des balises personnalisées pour que vous puissiez personnaliser chaque carte et en envoyer à autant de contacts que vous le souhaitez',
		downloadCsvTemplate: 'Télécharger le modèle CSV',
		csvColumnsLabel: 'Colonnes :',
		csvExtraColumns: '. Les colonnes supplémentaires deviennent des balises de fusion.',
		csvExampleLabel: 'Exemple :',
		changeFile: 'Changer de fichier',
		csvFileLabel: 'Fichier CSV',
		clickToUpload: 'Cliquez pour téléverser votre fichier csv',

		// Recipients table / list
		recipientsHeader: 'DESTINATAIRES',
		missingFields: 'Champs manquants',
		errorsCount: '%{count} erreur(s)',
		invalidRecipientEmails: 'E-mails de destinataires invalides',
		invalidEmailsCount: '%{count} e-mail(s) invalide(s)',
		fromLabel: 'De',
		listSuffix: 'liste',
		addNewRecipient: 'Ajouter un nouveau destinataire',
		copyCardUrl: "Copier l'URL de la carte",
		scheduleForLater: 'Programmer pour plus tard',
		saveAndNext: 'Enregistrer et suivant',
		selectAll: 'Tout sélectionner',
		unnamed: 'Sans nom',
		noRecipientsFound: 'Aucun destinataire trouvé.',

		// Toasts / swal (recipients)
		updatedRecipientSuccess: 'Destinataire mis à jour avec succès',
		addedRecipientSuccess: 'Destinataire ajouté avec succès',
		decrementLimitByCount: 'Cette action réduira votre limite de destinataires de %{count} !',
		decrementLimit: 'Cette action réduira votre limite de destinataires !',
		linkCopied: 'Lien copié avec succès',

		// Copy card URL modal
		getCardUrls: 'Obtenir les URL de la carte',
		copyUrlDescription:
			'Vous pouvez copier l’URL des destinataires et la leur envoyer directement par n’importe quel moyen, par ex. messenger, whatsapp, etc.',
		downloadAsCsv: 'Télécharger en CSV',
		copyUrl: "Copier l'URL",
		noRecipientsToCopy: 'Aucun destinataire à copier.',

		// Schedule modals
		scheduleCard: 'Programmer la carte',
		addDateTimeDescription:
			'Ajoutons la date et l’heure auxquelles vous souhaitez que vos contacts reçoivent la carte. Vous pouvez aussi modifier la programmation manuellement pour chaque destinataire.',
		selectDateTime: 'Sélectionnez la date et l’heure',
		missingData: 'Données manquantes',
		missingDataDescription:
			'Il vous manque des données dans les colonnes, ce qui pourrait poser problème lors de l’envoi des cartes.',
		updateData: 'Mettre à jour les données',
		skipContinue: 'Ignorer et continuer',

		// Add recipient modal / form
		recipientInfo: 'Informations du destinataire',
		updateRecipientInfoDesc:
			'Mettez à jour les informations de vos destinataires afin qu’ils reçoivent correctement la carte.',
		addNameEmailDesc: 'Ajoutez le nom et l’adresse e-mail du destinataire',
		basicInfo: 'INFORMATIONS DE BASE',
		nameLabel: 'nom',
		emailLabel: 'e-mail',
		nameOfRecipient: 'Nom du destinataire',
		mergeTagsLabel: 'BALISES DE FUSION',
		recurring: 'Récurrent',
		yearly: 'Annuel',
		monthly: 'Mensuel',
		weekly: 'Hebdomadaire',
		daily: 'Quotidien',

		// Customize subject / preview
		whoIsCardFrom: 'De qui vient cette carte',
		recipientsLeft: 'Il vous reste %{count} destinataire(s)',
		unlimitedRecipients: 'Vous avez un nombre illimité de destinataires e-mail',
		customizeSubjectEmail: "Personnalisez l'objet de l'e-mail.",
		customizeHeader: "Personnalisez l'en-tête de l'aperçu de la carte",
		customizeFooter: "Personnalisez le pied de page de l'aperçu de la carte",
		addCta: 'Ajouter un CTA dans la carte d’aperçu',
		toggleConfetti: 'Activer/désactiver les confettis',
		howCardLooksEmail: 'À quoi ressemble la carte dans l’e-mail ?',
		howCardLooksViewScreen: 'À quoi ressemble la carte sur l’écran de visualisation de la carte ?',
		enterSenderName: 'Saisissez le nom de l’expéditeur',
		subjectLinePlaceholder: 'Bonjour %{tag}, %{name} a créé une carte numérique pour vous.',
		subjectLineFromPlaceholder: 'Bonjour %{tag}, de %{name} a créé une carte numérique pour vous.',
		cardPreviewHeaderPlaceholder: 'En-tête de l’aperçu de la carte',
		cardPreviewFooterPlaceholder: 'Pied de page de l’aperçu de la carte',
		unsubscribeTextPlaceholder: 'Texte du lien de désabonnement (facultatif)',
		ctaTextLabel: 'Texte',
		ctaPlaceholder: 'Cliquez ici',
		subjectLineHint:
			'Ajoutez un nom d’expéditeur préféré et une ligne d’objet. Vous pouvez aussi ajouter des balises de fusion dans la ligne d’objet',

		// Scheduled recipients table / fallback date
		cardsReadyToSchedule: 'Carte(s) prête(s) à programmer',
		manualScheduleHint: 'Vous pouvez modifier manuellement la programmation de chaque carte si vous le souhaitez',
		sendDateFallbackLabel: 'Date d’envoi pour les destinataires sans date dans le CSV',
		fallbackHintCsv:
			'Les destinataires ayant un schedule_date valide dans votre CSV conservent leur propre date. Cette date de repli s’applique à tous les autres.',
		fallbackHintNoCsv:
			'Applique cette date à chaque destinataire. Remplacez les lignes individuelles dans le tableau ci-dessous.',
		pickFallbackDate: 'Choisissez une date de repli',
		applyScheduleDates: 'Appliquer les dates de programmation',
		sendCard: 'Envoyer la carte',
		scheduledAt: 'Programmé pour',
		now: 'Maintenant',
		noSelectedRecipients: 'Aucun destinataire sélectionné trouvé.',

		// Email preview
		emailFooterDefault: 'Votre boîte de réception vient de recevoir une livraison spéciale. Voyez votre carte en ligne.',
		viewCard: 'Voir la carte',
		unsubscribe: 'se désabonner',

		// Toasts / swal (schedule / apply)
		cardScheduledSuccess: 'Carte programmée !',
		saveCardProblem: 'Un problème est survenu lors de l’enregistrement de votre carte. Veuillez réessayer.',
		pickFallbackOrCsv: 'Choisissez une date d’envoi de repli ou téléversez un CSV avec une colonne schedule_date.',
		scheduleAppliedCount: 'Programmation appliquée à %{count} destinataire(s).',
		applyScheduleFailed: 'Échec de l’application des dates de programmation. Veuillez réessayer.',
	} as Record<string, string>,
};
export default schedule;
